module.exports = __webpack_public_path__ + "img/52a99bf440ce82f693c81acf5e58be6.dfc99f3d.png";